export interface QuickOrderResponse {
    title: string;
    link: string;
    linkTitle: string;
    inputLabel?: string;
    inputPlaceholder?: string;
    orderButton?: string;
    suggestionUrl?: string;
    orderUrl?: string;
    materialNumberParamName?: string;
    amountParamName?: string;
    noData?: boolean;
    noDataText?: string;
}
